import { logAndylitics, log, logAPI } from "./andyliticsApi";
import * as tools from "../helpers/Tools";


const apiBaseUrl = typeof window !== 'undefined' ? window.serverData.data.apiBaseUrl : ''; // window is undefined during pre-render
const myBswHealthBffBaseUrl = typeof window !== 'undefined' ? window.serverData.data.mybswhealthbff : '';
const functionsKey = typeof window !== 'undefined' ? window.serverData.data.mybswhealthbfffunctionskey : '';
const surveyUrl = typeof window !== 'undefined' ? window.serverData.data.surveyUrl : '';
//const xealthApiUrl = typeof window !== 'undefined' ? window.serverData.data.xealthapiurl : '';
//const xealthApiFunctionskey = typeof window !== 'undefined' ? window.serverData.data.xealthapifunctionskey : '';

export const getJourneyConversationId = (token, messageId) => {
    const url = `${myBswHealthBffBaseUrl}v1/xealthToTwistle?messageId=${messageId}`;

    const params = {
        headers: {
            "x-functions-key": functionsKey,
            "content-type": "application/json",
            "accept": "application/json",
            "Authorization": `bearer ${token}`
        },
        method: "GET"
    };
    const start = new Date();

    return fetch(url, params)
        .then(resp => {
            logAPI("MBHWeb.Api.Dashboard.GetXealthMessage", start, url);
            return resp.json();
        })
        .catch(err => {
            logAPI("MBHWeb.Api.Dashboard.GetXealthMessage.Failure", start, url, err);
            return Promise.reject(err);
        });

}; 



/**
 * Returns dashboard data for the given login id.
 * 
 * @param {any} loginId loginId of the logged-in user.
 * @param {any} token user's auth token.
 * @param {any} proxyId user's proxy ID.
 * @returns {any} epic dashboard data.
 */
export const getEpicDashboardData = (loginId, token, proxyId) => {
    //debugger;
    //throw "this one failed!";
    const proxyIdParam = proxyId ? '&proxyPatientId=' + proxyId + '&proxyPatientIdType=External' : "";
    const url = `${apiBaseUrl}v2/epic/GetEpicDashboardData?loginId=${encodeURIComponent(loginId)}${proxyIdParam}`;
    const start = new Date();
    return fetch2(url, token).then(response => {
        logAPI("MBHWeb.Api.Dashboard.GetEpicData", start, url);
        return response;
    }).catch(err => { logAPI("MBHWeb.Api.Dashboard.GetEpicData.Failure", start, url, err); return Promise.reject(err);});
};

export const proxyInfo = (userName, token) => {
    const url = `${apiBaseUrl}v4/Epic/GetProxyInformation?userName=${encodeURIComponent(userName)}&getEvisitInfo=true&excludeExpiredProxies=true`
    const start = new Date();
    return fetch2(url, token).then(response => {
        logAPI("MBHWeb.Api.MyChart.GetProxyInfo", start, url, response);
        return response;
    }).catch(err => { logAPI("MBHWeb.Api.MyChart.GetProxyInfo.Failure", start, url, err); return Promise.reject(err); });
};

export const getZipnosisEvisitUrl = (token, loginId, zipGroupId, proxyPatientId, proxyPatientIdType) => {
    const url = `${apiBaseUrl}v4/Epic/GetZipnosisEvisitUrl`;
    const start = new Date();
    let data = { loginId, zipGroupId };
    if (proxyPatientId && proxyPatientIdType) {
        data = { ...data, proxyPatientId, proxyPatientIdType };
    }
    return fetch2(url, token, JSON.stringify(data), 'POST').then(response => {
        logAPI("MBHWeb.Api.MyChart.GetZipnosisEvisitUrl", start, url);
        return response;
    }).catch(err => {
        logAPI("MBHWeb.Api.MyChart.GetZipnosisEvisitUrl.Failure", start, url, err); return Promise.reject(err);
    });
};

export const getTodos = (loginId, patientId, token) => {
    const queryStrings = `?loginId=${encodeURIComponent(loginId)}&patientId=${patientId}&patientIdType=External`;
    const url = `${apiBaseUrl}v2/epic/GetPatientHealthAdvisories${queryStrings}`;
    const start = new Date();
    return fetch2(url, token).then(response => {
        logAPI("MBHWeb.Api.MyChart.GetPatientHealthAdvisories", start, url);
        return response;
    }).catch(err => { logAPI("MBHWeb.Api.MyChart.GetPatientHealthAdvisories.Failure", start, url, err); return Promise.reject(err); });
};

export const getEvisitEligibility = (userName, token) => {
    const uname = encodeURIComponent(userName);
    const url = `${apiBaseUrl}v2/epic/getEvisitEligibility?userName=${encodeURIComponent(userName)}`;
    const start = new Date();
    return fetch2(url, token).then(response => {
        logAPI("MBHWeb.Api.eVisits.GetEvisitEligibility.Get", start, url);
        return response;
    }).catch(err => { logAPI("MBHWeb.Api.eVisits.GetEvisitEligibility.Get.Failure", start, url, err); return Promise.reject(err); });
};

export const getLetters = (loginId, token, myChartId, proxyPatientId) => {
    const url = `${apiBaseUrl}v3/Epic/GetLetters`;
    const start = new Date();

    let data = { loginId, myChartId, proxyPatientId, proxyPatientIdType: proxyPatientId ? 'External' : null };
   
    return fetch2(url, token, JSON.stringify(data), 'POST').then(response => {
        logAPI("MBHWeb.Api.MyChart.GetLetters", start, url);
        return response;
    }).catch(err => {
        logAPI("MBHWeb.Api.MyChart.GetLetters.Failure", start, url, err); return Promise.reject(err);
    });
};



export const getProxyRelationshipTypes = (token) => {
    const fullUrl = `${apiBaseUrl}v2/Epic/GetProxyRelationshipTypes`;

    let params = {
        headers: {
            Authorization: `bearer ${token}`
        },
        method: "GET"
    };

    var start = new Date();

    return fetch(fullUrl, params)
        .then(response => {
            logAPI("MBHWeb.Api.Epic.Proxy.GetProxyRelationshipTypes", start, fullUrl);
            return response.json();
        })
        .catch(error => {
            logAPI("MBHWeb.Api.Epic.Proxy.GetProxyRelationshipTypes.Failure", start, fullUrl, error);
            return Promise.reject(error);
        });
};

export const setProxyRelationship = (token, patientId, patientIdType, proxyId, proxyIdType, relation, fromDate, toDate, comments) => {
    const fullUrl = `${apiBaseUrl}v2/Epic/SetProxyRelationship`;
    
    let postBody = {
        "PatientId": patientId,
        "PatientIdType": patientIdType,
        "ProxyId": proxyId,
        "ProxyIdType": proxyIdType,
        "Relation": relation,
        "FromDate": fromDate,
        "ToDate": toDate,
        "Comments": comments
    };

    let params = {
        headers: {
            Authorization: `bearer ${token}`,
            "Accept": "application/json",
            "Content-type": "application/json",
            "Cache-Control": "no-cache",
            "Pragma": "no-cache"
        },
        body: JSON.stringify(postBody),
        method: "POST"
    };

    var start = new Date();

    return fetch(fullUrl, params)
        .then(response => {
            logAPI("MBHWeb.Api.Epic.Proxy.SetProxyRelationship", start, fullUrl);
            return response.json();
        })
        .catch(error => {
            logAPI("MBHWeb.Api.Epic.Proxy.SetProxyRelationship.Failure", start, fullUrl, error);
            return Promise.reject(error);
        });

};

export const acceptProxyRelationship = (token, grantorId, grantorDob) => {
    const fullUrl = `${apiBaseUrl}v2/Epic/AcceptProxyRelationship`;

    let postBody = {
        "GrantorId": grantorId,
        "GrantorDob": grantorDob
    };

    let params = {
        headers: {
            Authorization: `bearer ${token}`,
            "Accept": "application/json",
            "Content-type": "application/json",
            "Cache-Control": "no-cache",
            "Pragma": "no-cache"
        },
        body: JSON.stringify(postBody),
        method: "POST"
    };

    var start = new Date();

    return fetch(fullUrl, params)
        .then(response => {
                return response.json().then((body) => {
                    return { response, body };
                })
                .then((request) => {
                    if (request.response.ok) {
                        logAPI("MBHWeb.Api.Epic.Proxy.AcceptProxyRelationship", start, fullUrl);
                        return request.body;
                    }
                    else {
                        logAPI("MBHWeb.Api.Epic.Proxy.AcceptProxyRelationship.Failure", start, fullUrl, request.body);
                        return Promise.reject(request.body);
                    }
                });
        })
        .catch(error => {
            logAPI("MBHWeb.Api.Epic.Proxy.AcceptProxyRelationship.Failure", start, fullUrl, error);
            return Promise.reject(error);
        });
};     

export const grantProxyRelationship = (token, accessorName, accessorEmail, type) => {
    const fullUrl = `${apiBaseUrl}v2/Epic/GrantProxyRelationship`;

    let epicGrantProxyRelationshipRequest = {
        "AccessorName": accessorName,
        "AccessorEmail": accessorEmail,
        "RequestType": type
    };

    let params = {
        headers: {
            Authorization: `bearer ${token}`,
            "Accept": "application/json",
            "Content-type": "application/json",
            "Cache-Control": "no-cache",
            "Pragma": "no-cache"
        },
        body: JSON.stringify(epicGrantProxyRelationshipRequest),
        method: "POST"
    };

    var start = new Date();

    return fetch(fullUrl, params)
        .then(response => {
            logAPI("MBHWeb.Api.Epic.Proxy.GrantProxyRelationship", start, fullUrl);
            return response.json();
        })
        .catch(error => {
            logAPI("MBHWeb.Api.Epic.Proxy.GrantProxyRelationship.Failure", start, fullUrl, error);
            return Promise.reject(error);
        });
};

export const deleteProxyRelationship = (token, patientId, patientIdType) => {
    const fullUrl = `${apiBaseUrl}v2/Epic/DeleteProxyRelationship?proxyPatientId=${patientId}&proxyPatientIdType=${patientIdType}`;

    let params = {
        headers: {
            Authorization: `bearer ${token}`
        },
        method: "DELETE"
    };

    var start = new Date();

    return fetch(fullUrl, params)
        .then(response => {
            logAPI("MBHWeb.Api.Epic.Proxy.DeleteProxyRelationship", start, fullUrl);
            return response.json();
        })
        .catch(error => {
            logAPI("MBHWeb.Api.Epic.Proxy.DeleteProxyRelationship.Failure", start, fullUrl, error);
            return Promise.reject(error);
        });
};

/**
 * the mybswhealth bffdashboard contains video visit appointment details and xealthMessages for primary user and its proxies.
 * 
 * @param {any} token user's auth token
 * @returns {any} dashboard data from the new bff.
 */
export const getBffDashboard = (token) => {
    const url = `${myBswHealthBffBaseUrl}v5/dashboard`;
    //debugger;
    //throw "this one failed!";

    //const url = `${myBswHealthBffBaseUrl}v4/web/dashboard`;

    const params = {
        headers: {
            "x-functions-key": functionsKey,
            "content-type": "application/json",
            "accept": "application/json",
            "Authorization": `bearer ${token}`
        },
        method: "GET"
    };
    const start = new Date();

    return fetch(url, params)
        .then(resp => {
            return resp.json();
        })
        .then(json => {
            logAPI("MBHWeb.Api.Dashboard.BffDashboard", start, url, json);
            return json;
        })
        .catch(err => {
            logAPI("MBHWeb.Api.Dashboard.BffDashboard.Failure", start, url, err);
            return Promise.reject(err);
        });

};

/**
 * get a specific xealthMessage with messageId
 * @param {any} token user's auth token
 * @param {any} messageId message id
 * @returns {any} the specific xealthMessage
 */
export const getXealthMessage = (token, messageId) => {
    const url = `${myBswHealthBffBaseUrl}v1/xealthmessage?messageId=${messageId}`;

    const params = {
        headers: {
            "x-functions-key": functionsKey,
            "content-type": "application/json",
            "accept": "application/json",
            "Authorization": `bearer ${token}`
        },
        method: "GET"
    };
    const start = new Date();

    return fetch(url, params)
        .then(resp => {
            logAPI("MBHWeb.Api.Dashboard.GetXealthMessage", start, url);
            return resp.json();
        })
        .catch(err => {
            logAPI("MBHWeb.Api.Dashboard.GetXealthMessage.Failure", start, url, err);
            return Promise.reject(err);
        });

}; 


export const getConditions = (token) => {
    const url = `${myBswHealthBffBaseUrl}conditions`;
    const params = {
        headers: {
            "Authorization": `bearer ${token}`,
            "accept": "application/json",
            "x-functions-key": functionsKey
        },
        method: "GET"
    };
    const start = new Date();

    return fetch(url, params)
        .then(resp => {
            logAPI("MBHWeb.Api.Dashboard.VideoVisit.GetConditions", start, url);
            return resp.json();
        })
        .catch(err => {
            logAPI("MBHWeb.Api.Dashboard.VideoVisit.GetConditions.Failure", start, url, err);
            return Promise.reject(err);
        });
};

export const getTimeSlots = (token, clientUTCOffset, date) => {
    const providerId = typeof window !== 'undefined' && window.serverData.data.providerId ? window.serverData.data.providerId : '153284';

    const url = `${myBswHealthBffBaseUrl}slots?resIdtype=EXTERNAL&resid=${providerId}&clientutcoffset=${clientUTCOffset}&clienttoday=${date}`;
    const params = {
        headers: {
            "Authorization": `bearer ${token}`,
            "accept": "application/json",
            "x-functions-key": functionsKey
        },
        method: "GET"
    };
    const start = new Date();

    return fetch(url, params)
        .then(resp => {
            logAPI("MBHWeb.Api.Dashboard.VideoVisit.GetTimeSlots", start, url);
            if (resp.status === 200) return resp.json();
            else return resp;
        })
        .catch(err => {
            logAPI("MBHWeb.Api.Dashboard.VideoVisit.GetTimeSlots.Failure", start, url, err);
            return Promise.reject(err);
        });
};

export const scheduleVideoVisit = (token, scheduleRequestData) => {
    const url = `${myBswHealthBffBaseUrl}v3/schedule`;
    const params = {
        headers: {
            "Authorization": `bearer ${token}`,
            "accept": "application/json",
            "x-functions-key": functionsKey
        },
        body: JSON.stringify(scheduleRequestData.data),
        method: "PUT"
    };
    const start = new Date();

    return fetch(url, params)
        .then(resp => {
            logAPI("MBHWeb.Api.Dashboard.VideoVisit.ScheduleVideoVisit", start, url);
            if (resp.status === 200) return resp.json();
            else return resp;
        })
        .catch(err => {
            logAPI("MBHWeb.Api.Dashboard.VideoVisit.ScheduleVideoVisit.Failure", start, url, err);
            return Promise.reject(err);
        });
};  

export const ambulatorySurveyRequest = (token, surveyRequest) => {
    const url = `${surveyUrl}api/SurveyQuestionResponse`;
    const params = {
        headers: {
            "Authorization": `bearer ${token}`,
            "accept": "application/json",
            "x-functions-key": functionsKey
        },
        body: JSON.stringify(surveyRequest.data),
        method: "POST"
    };
    const start = new Date();
    return fetch(url, params)
        .then(resp => {
            logAPI("MBHWeb.Api.AmbulatorySurvey.Success", start, url);
            if (resp && resp.status === 200) return resp.status;
            else {
                return Promise.reject(resp);
            }
        })
        .catch(err => {
            logAPI("MBHWeb.Api.AmbulatorySurvey.Failure", start, url, err);
            return Promise.reject(err);
        });
};


export const eCheckInStatus = (userName, csnId, token) => {
    const url = `${apiBaseUrl}v4/epic/GeteCheckinStatus?userName=${encodeURIComponent(userName)}&CSNId=${csnId}`;
    const params = {
        headers: {
            "Authorization": `bearer ${token}`,
            "accept": "application/json"
        },
        method: "GET"
    };

    const start = new Date();

    return fetch(url, params)
        .then(resp => {
            logAPI("MBHWeb.Api.Epic.VideoVisit.ECheckInStatus", start, url);
            return resp.json();
        })
        .catch(err => {
            logAPI("MBHWeb.Api.Epic.VideoVisit.ECheckInStatus.Failure", start, url, err);
            return Promise.reject(err);
        });
};

//export const dcjSelfOrderApi = (token, myChartId, programId) => {
//    const url = `${surveyUrl}v1/partner/orders`;
//    const body = {
//        "myChartId": myChartId, "programId": programId
//    };
//    const params = {
//        headers: {
//            "content-type": "application/json",
//            "accept": "application/json",
//            "Authorization": `bearer ${token}`,
//            "x-functions-key": xealthApiFunctionskey
//        },
//        body: JSON.stringify(body),
//        method: "POST"
//    };
//    const start = new Date();
//    return fetch(url, params)
//        .then(resp => {
//            logAPI("MBHWeb.Api.Epic.DcjSelfOrder.Success", start, url);
//            if (resp && resp.status === 200) return resp.status;
//            else {
//                return Promise.reject(resp);
//            }
//        })
//        .catch(err => {
//            logAPI("MBHWeb.Api.Epic.DcjSelfOrder.Failure", start, url, err);
//            return Promise.reject(err);
//        });
//};

//export const dcjSelfOrderOptOut = (token, myChartId, programId) => {
//    const url = `${surveyUrl}v1/partner/optout`;
//    const body = {
//        "MyChartId": myChartId, "ProgramId": programId
//    };
//    const params = {
//        headers: {
//            "content-type": "application/json",
//            "accept": "application/json",
//            "Authorization": `bearer ${token}`,
//            "x-functions-key": xealthApiFunctionskey
//        },
//        body: JSON.stringify(body),
//        method: "POST"
//    };
//    const start = new Date();
//    return fetch(url, params)
//        .then(resp => {
//            logAPI("MBHWeb.Api.Epic.DcjSelfOrderOptOut.Success", start, url, body);
//            if (resp && resp.status === 204) return resp.status;
//            else {
//                return Promise.reject(resp);
//            }
//        })
//        .catch(err => {
//            logAPI("MBHWeb.Api.Epic.DcjSelfOrderOptOut.Failure", start, url, err);
//            return Promise.reject(err);
//        });
//};

export const encryptCSN = (csnId, token) => {
    const url = `${apiBaseUrl}v3/Epic/EncryptCsn?csn=${csnId}`;
    const params = {
        headers: {
            "Authorization": `bearer ${token}`,
            "accept": "application/json"
        },
        method: "GET"
    };

    const start = new Date();

    return fetch(url, params)
        .then(resp => {
            logAPI("MBHWeb.Api.Epic.EncryptCSN.Success", start, url);
            return resp.json();
        })
        .catch(err => {
            logAPI("MBHWeb.Api.Epic.EncryptCSN.Failure", start, url, err);
            return Promise.reject(err);
        });
};

export const getMyChartStatus = (myChartId, myChartIdType, token) => {
    const url = `${apiBaseUrl}v4/Epic/LookupPatientAndMyChartAccount`;
    const body = {
        "ID": myChartId, "IDType": myChartIdType
    };
    const params = {
        headers: {
            "Authorization": `bearer ${token}`,
            "content-type": "application/json",
            "accept": "application/json"
        },
        body: JSON.stringify(body),
        method: "POST"
    };

    const start = new Date();

    return fetch(url, params)
        .then(resp => {
            logAPI("MBHWeb.Api.Epic.MyChartStatus.Success", start, url);
            if (resp && resp.status === 200) return resp.json();
            else {
                return Promise.reject(resp);
            }
        })
        .catch(err => {
            logAPI("MBHWeb.Api.Epic.MyChartStatus.Failure", start, url, err);
            return Promise.reject(err);
        });
};

export const getCareCompanionEnrollStatus = (token, patientId) => {
    const fullUrl = `${apiBaseUrl}v6/epic/CareCompanionEnrollStatus?patientId=${patientId}&patientIdType=External`;

    let params = {
        headers: {
            Authorization: `bearer ${token}`
        },
        method: "GET"
    };

    var start = new Date();

    return fetch(fullUrl, params)
        .then(response => {
            logAPI("MBHWeb.Api.Epic.CareCompanionEnrollStatus.Success", start, fullUrl, null, patientId);
            return response.json();
        })
        .catch(error => {
            logAPI("MBHWeb.Api.Epic.CareCompanionEnrollStatus.Failure", start, fullUrl, error);
            // story 125109: enable care companion in the event of api failure
            return { CareCompanionEnrolled: true };
            //return Promise.reject(error);
        });
};